import React from "react";
var __jsx = React.createElement;
import { getMonthYear } from "@lib/util/date-ops";
import { useNavigation } from "react-day-picker";
import APP_CONFIGURATION from "@lib/app.config";
import Icons from "../../../icons";
const CalendarCaption = props => {
  const {
    goToMonth,
    nextMonth,
    previousMonth
  } = useNavigation();
  return __jsx("div", {
    className: "flex flex-row justify-between items-center py-4 w-full cursor-pointer"
  }, props.monthsQuantity == 1 || props.displayIndex == 0 ? __jsx("span", {
    "aria-label": "Previous month",
    onKeyDown: e => {
      if (e.key === 'Enter') {
        previousMonth && goToMonth(previousMonth);
      }
    },
    onClick: () => previousMonth && goToMonth(previousMonth),
    className: "flex justify-center items-center rounded-md  shadow-sm min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px] cursor-pointer"
  }, __jsx(Icons.chevronLeft, {
    size: 16,
    color: APP_CONFIGURATION.colors.neutral_black,
    withStroke: true
  })) : __jsx("div", {
    className: "min-w-[40px] max-w-[40px]"
  }), __jsx("span", {
    className: "tx-pmd-semiBold text-center text-neutral_black"
  }, getMonthYear(props.displayMonth.toISOString())), props.monthsQuantity === 1 || props.displayIndex === 1 ? __jsx("span", {
    "aria-label": "Next month",
    onKeyDown: e => {
      if (e.key === 'Enter') {
        nextMonth && goToMonth(nextMonth);
      }
    },
    onClick: () => nextMonth && goToMonth(nextMonth),
    className: "flex justify-center items-center rounded-md shadow-sm min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px] cursor-pointer"
  }, __jsx(Icons.chevronRight, {
    size: 16,
    color: APP_CONFIGURATION.colors.neutral_black,
    withStroke: true
  })) : __jsx("div", {
    className: "min-w-[40px] max-w-[40px]"
  }));
};
export default CalendarCaption;